module.exports = __webpack_public_path__ + "img/aboutus_person1.eb8ed937.png";